export default "__VITE_ASSET__0biYnNoF__"